import React from "react"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import { Box, Center, Spinner, useTheme } from "@chakra-ui/react"
import { RiGpsLine } from "react-icons/ri"
import { TrackerMapProps } from "./TrackerMapMapbox"
import { TRACKER_MARKER_COLORS } from "../lib/static/tracker"
import GMap from "../gmaps/GMap"
import { useGoogleMapsInitBounds } from "../lib/hooks/useGoogleMapsInitBounds"
import { createBbox } from "../lib/helpers/map"

const TrackerMapGoogleMap: React.FC<TrackerMapProps> = ({ tracker, isLoading }) => {
  const theme = useTheme()
  const bbox = React.useMemo(() => createBbox([[tracker.longitude!, tracker.latitude!]]), [tracker])
  const gMapBounds = useGoogleMapsInitBounds(bbox)
  return (
    <GMap
      mapId="tracker-gmap"
      containerStyle={{
        height: "50vh",
        width: "100%",
      }}
      initialBounds={gMapBounds}
      gestureHandling="cooperative"
      zoomControl={false}
    >
      {isLoading && (
        <Center pos="absolute" w="100%" bottom={8}>
          <Center p={2} bg="white" borderRadius="md" h={50} w={50}>
            <Spinner size="sm" />
          </Center>
        </Center>
      )}

      {tracker.state && tracker.latitude && tracker.longitude && !isLoading && (
        <AdvancedMarker
          position={{
            lat: tracker.latitude,
            lng: tracker.longitude,
          }}
          data-state={tracker.state}
        >
          <Center
            boxSize="40px"
            zIndex={1}
            borderRadius="50%"
            overflow="hidden"
            bg={theme.colors[TRACKER_MARKER_COLORS[tracker.state || "unknown"]]["600"] || "blue.600"}
          >
            <Box boxSize="22px" color="white" as={RiGpsLine} />
          </Center>
        </AdvancedMarker>
      )}
    </GMap>
  )
}

export default TrackerMapGoogleMap
